import dogIMG from '../../assets/dog-walker.png';
import cookingIMG from '../../assets/cooking.png';
import technologyIMG from '../../assets/technology.png';
import gardeningIMG from '../../assets/gardening.png';
import photographyIMG from '../../assets/photography.png';

export const randomImages = [dogIMG, cookingIMG, technologyIMG, gardeningIMG, photographyIMG];